import { inject, Injectable, Injector } from '@angular/core';
import { take, tap } from 'rxjs/operators';
import { ApActiveModal, ApModalHelperFactoryBase } from 'webcommon/core-ui/modals-ng1520';

import { ApModalHelper } from './ApModalHelper';

import { DialogRef } from '@angular/cdk/dialog';

// todo: combine some logic with projects/webcommon-next/core-ui/modals/ApModalHelperFactory.ts
// with the only difference being the new ApModalHelper<T>()
@Injectable({
  providedIn: 'root',
})
export class ApModalHelperFactory extends ApModalHelperFactoryBase {
  // This should be the injector from the component, not an Injector
  // injected directly into a service.
  create<T>(_elementInjector: Injector, hideHandler: (reason: string) => void): ApModalHelper<T> {
    const dialogRef = inject(DialogRef);
    const activeModal = inject<ApActiveModal<T>>(ApActiveModal);
    const closeTeardown = dialogRef.closed
      .pipe(
        take(1),
        tap(() => {
          hideHandler('closeAll(), ngOnDestroy(), escape, backdrop-click, or overlay-detached');
        }),
      )
      .subscribe();
    activeModal.setup(dialogRef, () => {
      closeTeardown.unsubscribe();
    });
    const modalHelper = new ApModalHelper<T>();
    return modalHelper;
  }
}
